import { render, staticRenderFns } from "./ValidateRecovery.vue?vue&type=template&id=7ae4671e&"
import script from "./ValidateRecovery.vue?vue&type=script&lang=js&"
export * from "./ValidateRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports